import config from '@config';
import { mockViewScroll } from '$assets/js/device';
import router from '@router';
import utils from 'blue-utils';

const viewScrollClassName = '.bv-view-scroll';

//获取的view element
function getScrollElm() {
  if (this.$el.nodeType === 1) {
    return this.$el.children[0];
  }
  return null;
}

//获取当前的view层elm
export function getLastViewElm() {
  const viewScrolls = document.querySelectorAll(viewScrollClassName);
  if (viewScrolls && viewScrolls.length > 0) {
    return viewScrolls[viewScrolls.length - 1];
  }
  return null;
}


//set view scroll event
export function setViewEvent() {
  const scrollElm = getScrollElm.call(this);
  if (!scrollElm) return;
  let timer = 0;

  //设置父级view组件的scroll状态
//  setParentViewScroll({
//    scrollElm,
//    type: 'mounted'
//  });

  //view scroll event
  scrollElm.addEventListener('scroll', (event) => {
    const elm = event.target;
    const scrollTop = elm.scrollTop;
    //节流处理scrollTop
    clearTimeout(timer);
    timer = setTimeout(() => {
      //组件内的scroll记录
      this.scroll.top = scrollTop;
      //针对的keep-alive中vue针对scroll抓取pageXOffset
      if (router.currentRoute.meta.keepAlive !== false) {
        window.pageYOffset = scrollTop;
      }
    }, 150);

    //滑动的时候也隐藏子菜单的状态
    this.hideTabBarSubMenu();

    //阻止scroll冒泡
    event.stopPropagation();


  }, false);
}

//设置当前elm的scroll
export function setCurrentViewScroll(position = {
  x: 0,
  y: 0
}) {
  const lastView = getLastViewElm();
  lastView && (lastView.scrollTop = position.y);
}


//设置父级view组件的scroll状态,keep-alive不适用
  export function setParentViewScroll(opts = {}) {

  console.log(opts)

  const { scrollElm, type } = opts;

  const viewScrolls = document.querySelectorAll(viewScrollClassName);

  const findIndex = [].indexOf.call(viewScrolls, scrollElm);
  if (type === 'mounted') {
    if (viewScrolls.length >= 2) {
      [].forEach.call(viewScrolls, (viewElm, index) => {
        if (index < findIndex) {
          viewElm.style.overflowY = 'hidden';
        }
      });
    }
  } else if (type === 'destroyed' && scrollElm) {
    scrollElm.style.overflowY = 'scroll';
  }
}

//查找父级的view元素
export function findParentView() {
  const elm = getScrollElm.call(this);
  const viewScrolls = document.querySelectorAll(viewScrollClassName);
  if (viewScrolls.length >= 2 && elm) {
    const findIndex = [].indexOf.call(viewScrolls, elm);
    return viewScrolls[findIndex - 1];
  }
  return null;
}

//ios input bug
export function inputEvent() {
  const device = config.device;
  if (device.isWap && (device.isIPhone || device.isIPad)) {
    mockViewScroll();
  }
}